<!-- modified from https://vuejsexamples.com/generate-calendar-datepicker-with-datefns-and-vue-js/ -->
<template>
  <section class="calendar" :class="{singleItem: activeSingle}">
    <header class="dateHeader">
      <button v-if="showMonthNav" class="subtleButton dateBrowse" @click="changeDate('prev')"><span class="icontext">Previous</span><span aria-hidden="true">&#60;&#60;</span></button>
      <span>{{ currentMonthLabel }} {{ currentYear }}</span>
      <button  v-if="showMonthNav" class="subtleButton dateBrowse" @click="changeDate('next')"><span class="icontext">Next</span><span aria-hidden="true">&#62;&#62;</span></button>
    </header>
    <nav class="calendarKey">
      <ul>
        <li :class="{demphasize: activeSingle && activeSingle !== activity.id}" :key="activity.id" v-for="activity in activities" @click="showOne(activity.id)"><span class="dot" v-bind:class="'dot-' + activitiesToClasses.indexOf(activity.id.toString())"></span>{{ activity.title }}</li>
      </ul>
    </nav>
    <div class="alert" v-if="Object.keys(activities).length > 8">
      Note: the calendar supports a maximum of 8 activities
    </div>
    <div v-if="changeDateActive">
      <input ref="changeDateInput" type="date" @blur="changeDate('input')" :value="activeDate" name="activeDate" />
      <br />
      <input type="button" value="save" />
    </div>
    <div class="calendarBody">
      <div class="headings" :key="dayLabel.key" v-for="dayLabel in dayLabels">
        {{ dayLabel.label }}
      </div>
      <div v-bind:key="day.key" v-for="(day) in daysArray"
           class="day"
           :class="dayClassObj(day)">
        <button @click="setSelectedDate(day)">
          {{ day.date | formatDateToDay }}
          <span  v-for="index in day.activities" :key="index" class="dot" v-bind:class="'dot-' + activitiesToClasses.indexOf(index.toString())"></span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import {store} from '@/store'
import { format as dateFnsformat, startOfMonth, endOfMonth, eachDay, isSameMonth, isToday, isSameDay, addDays, addMonths, setDate, lastDayOfMonth, getDay } from 'date-fns'
import Dates from '@/mixins/Dates.js'
import DataMain from '@/data/dataMain'
Vue.use(Dates)

const DAY_LABELS = ['S', 'M', 'T', 'W', 'Th', 'F', 'S']
const MONTH_LABELS = [
  'January', 'February', 'March',
  'April', 'May', 'June',
  'July', 'August', 'September',
  'October', 'November', 'December']

export default {
  name: 'CalendarMonth',
  data () {
    return {
      changeDateActive: false,
      dayLabels: false,
      showMonthNav: false,
      activeSingle: false
    }
  },
  computed: {
    activities () {
      return store.state.activities.active
    },
    activitiesToClasses () {
      return Object.keys(this.activities)
    },
    activitiesTracked () {
      return store.state.trackActivities.dates
    },
    activeDate () {
      return store.state.activeDate
    },
    activeDateObject () {
      const dateOBJ = new Date(this.activeDate)
      return this.$dateFunctions.setOffset(dateOBJ)
    },
    currentMonth () {
      return this.activeDateObject.getMonth()
    },
    currentMonthLabel () {
      return MONTH_LABELS[this.currentMonth]
    },
    currentYear () {
      return this.activeDateObject.getFullYear()
    },
    daysArray () {
      const date = this.activeDateObject
      const startOfMonthDay = startOfMonth(date)
      const endOfMonthDay = endOfMonth(date)

      const days = eachDay(startOfMonthDay, endOfMonthDay).map((day) => ({
        date: day,
        key: dateFnsformat(day, 'D'),
        isCurrentMonth: isSameMonth(new Date(this.currentYear, this.currentMonth), day),
        isToday: isToday(day),
        isSelected: isSameDay(this.activeDateObject, day),
        activities: this.activitiesTracked[dateFnsformat(day, 'YYYY-MM-DD')]
      }))

      // gen the days from last month
      let previousMonthCursor = lastDayOfMonth(addMonths(date, -1))
      const begIndex = getDay(days[0].date)
      for (let i = begIndex; i > 0; i--) {
        days.unshift({
          date: previousMonthCursor,
          isCurrentMonth: false,
          isToday: isToday(previousMonthCursor),
          isSelected: isSameDay(this.activeDateObject, previousMonthCursor)
        })
        previousMonthCursor = addDays(previousMonthCursor, -1)
      }

      // gen days for next month
      const daysNeededAtEnd = (days.length % 7 > 0) ? (7 - (days.length % 7)) : 0
      let nextMonthCursor = addMonths(date, 1)
      nextMonthCursor = setDate(nextMonthCursor, 1)
      for (let x = 1; x <= daysNeededAtEnd; x++) {
        days.push({
          date: nextMonthCursor,
          isCurrentMonth: false,
          isToday: isToday(nextMonthCursor),
          isSelected: isSameDay(this.activeDateObject, nextMonthCursor)
        })
        nextMonthCursor = addDays(nextMonthCursor, 1)
      }
      return days
    }
  },
  created () {
    this.dayLabels = {}
    let i = 0
    for (let d in DAY_LABELS) {
      d = {
        label: DAY_LABELS[i]
      }
      this.dayLabels[i] = d
      i++
    }
  },
  mounted () {

  },
  methods: {
    dayClassObj (day) {
      let activeSingleDone = false
      let activeSingleClass = 'class-0'
      if (this.activeSingle && day.activities && day.activities.includes(this.activeSingle) && day.activities.includes(this.activeSingle)) {
        activeSingleDone = true
        activeSingleClass = 'singleDone' + this.activitiesToClasses.indexOf(this.activeSingle.toString())
      }
      return {
        'today': day.isToday,
        'current': day.isCurrentMonth,
        'selected': day.isSelected,
        'singleDone': activeSingleDone,
        [activeSingleClass]: activeSingleDone
      }
    },
    setSelectedDate (day) {
      let d = dateFnsformat(day.date, 'YYYY-MM-DD')
      DataMain.getMonth(d)
      store.commit('setDate', {
        value: d
      })
    },
    showOne (id) {
      if (this.activeSingle === id) {
        this.activeSingle = false
      } else {
        this.activeSingle = id
      }
    }
  },
  filters: {
    formatDateToDay (val) {
      return dateFnsformat(val, 'D')
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/variables/variables';

.calendar {
  margin-top: 30px;
}
.calendarBody {
  border: 1px solid $brandSalmon;
  padding: 5px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  // max-width: 400px;
  margin: 0 auto 30px;
  width: 90%;
  max-width: 600px;

}
.calendarBody button {
  background-color: transparent;
  border: none;
  color: $brandDarkGray;
  min-height: 50px;
  position: relative;

}
.calendarBody .current button {
  color: #000000;
  height: 100%;
  width: 100%;
}
.calendarBody > div {
  border: 1px dashed $brandLightGrey25;
}
.calendarBody .today  {
  color: $brandSalmon;
  font-weight: bold;
}
.calendarBody .selected  {
  border: 2px solid $brandSalmon;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  &.dot-0 {
    background-color: $brandBrightGreen;
  }
  &.dot-1 {
    background-color: $brandSalmon;
  }
  &.dot-2 {
    background-color: $brandBlue;
  }
  &.dot-3 {
    background-color: $brandGreen;
  }
  &.dot-4 {
    background-color: $brandFuschia;
  }
  &.dot-5 {
    background-color: $brandLightPurple;
  }
  &.dot-6 {
    background-color: $brandPurple;
  }
  &.dot-7 {
    background-color: $brandBlueB;
  }
}

.calendarBody button .dot {
  position: absolute;
  width: 8px;
  height: 8px;
  &.dot-0 {
    top: calc(20% - 4px);
    right: calc(20% - 4px);
  }
  &.dot-1 {
    bottom: calc(20% - 4px);
    right: calc(20% - 4px);
  }
  &.dot-2 {
    bottom: calc(20% - 4px);
    // left: calc(20% - 4px);
    left: 20%;
  }
  &.dot-3 {
    top: calc(20% - 4px);
    // left: calc(20% - 4px);
    left: 20%;
  }
  &.dot-4 {
    top: calc(20% - 4px);
    left: calc(50% - 4px);
  }
  &.dot-5 {
    top: calc(50% - 4px);
    right: calc(20% - 4px);
  }
  &.dot-6 {
    bottom: calc(20% - 4px);
    left: calc(50% - 4px);
  }
  &.dot-7 {
    top: calc(50% - 4px);
    // left: calc(20% - 4px);
    left: 20%;
  }
}

.calendarKey li {
  cursor: pointer;
  &.demphasize {
    opacity: .5;
  }
}

.day {
  background-color: $brandLightGrey25;
  &.current {
    background-color: unset;
  }
}
.calendarBody .singleDone0 {
  background-color: $brandBrightGreen25;
}
.calendarBody .singleDone1 {
  background-color: $brandSalmon25;
}
.calendarBody .singleDone2 {
  background-color: $brandBlue25;
}
.calendarBody .singleDone3 {
  background-color: $brandGreen25;
}
.calendarBody .singleDone4 {
  background-color: $brandFuschia25;
}
.calendarBody .singleDone5 {
  background-color: $brandLightPurple25;
}
.calendarBody .singleDone6 {
  background-color: $brandPurple25;
}
.calendarBody .singleDone7 {
  background-color: $brandBlueB25;
}

</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarMonth.vue